import React__default from 'react';
import styled, { keyframes } from 'styled-components';
import { get } from '../../constants.js';
import Box from '../Box/Box.js';
import sx from '../../sx.js';

const SIZES = {
  xsmall: '16px',
  small: '24px',
  medium: '32px',
  large: '48px',
  xlarge: '84px',
  jumbo: '96px'
};

// TODO: add productive vs expressive variants

const MktgSpinner = ({
  size: sizeKey = 'medium',
  testId,
  delay,
  appearance = 'inherit',
  ariaLabel,
  ariaLabelledBy,
  ...props
}) => {
  const size = typeof sizeKey === 'number' ? sizeKey : SIZES[sizeKey];
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Wrapper, {
    "data-animation": true,
    sx: {
      display: 'inline-flex',
      verticalAlign: 'middle',
      width: size,
      height: size,
      justifyContent: 'center',
      alignItems: 'center'
    },
    appearance: appearance,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy
  }, /*#__PURE__*/React__default.createElement(SVG, {
    "data-animation": true,
    viewBox: '0 0 100 100 ',
    xmlSpace: "preserve"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "Mark",
    "data-animation": true
  }, /*#__PURE__*/React__default.createElement("path", {
    fill: "white",
    "data-animation": true,
    d: "M99.4 92.5L81.7 57c-.6 4.8-2.2 9.3-4.9 13.3L84 84.7 43.1 67.6c-7.9-3.3-11.6-12.4-8.3-20.3.1-.3.3-.6.4-1L50 16.7l14.8 29.6c3.8 7.7.7 17-6.9 20.8-.3.2-.6.3-1 .4l-.2.1 11.5 4.8c8.7-7.8 11-20.4 5.8-30.8L54.6 2.9C53.3.3 50.2-.7 47.6.6c-1 .5-1.8 1.3-2.3 2.3L26 41.7C19.6 54.5 24.8 70 37.6 76.4c.5.3 1 .5 1.5.7l53.7 22.5c2.6 1.1 5.7-.1 6.8-2.8.6-1.4.5-2.9-.2-4.3z"
  }), /*#__PURE__*/React__default.createElement("path", {
    fill: "white",
    "data-animation": true,
    d: "M31 78.4l-15 6.2 7.2-14.3c-2.7-4-4.3-8.6-4.9-13.3L.6 92.5c-1.3 2.6-.3 5.7 2.3 6.9 1.4.7 2.9.7 4.3.1l36.1-15.1-6.2-2.6c-2.2-.8-4.2-2-6.1-3.4z"
  })), /*#__PURE__*/React__default.createElement(Path, {
    className: "mark-background",
    "data-animation": true,
    d: "M78.6 62.6c4.4 2.3 3.9 7.9 3.9 7.9L94.7 95l-57-24.4s-15.6-10.2-6.9-28S50 4.5 50 4.5l20 40.7s9.2 17.9-13.4 28S5.7 95 5.7 95l11.1-24.2s1.6-7.5 3.9-8.5",
    fill: "none"
    // stroke={appearance === 'inherit' ? `#fff` : '#000'}
    ,
    strokeWidth: "13",
    strokeMiterlimit: "10",
    mask: "url(#Mark)",
    appearance: appearance
  }), /*#__PURE__*/React__default.createElement(Path, {
    className: "mark-foreground",
    "data-animation": true,
    d: "M78.6 62.6c4.4 2.3 3.9 7.9 3.9 7.9L94.7 95l-57-24.4s-15.6-10.2-6.9-28S50 4.5 50 4.5l20 40.7s9.2 17.9-13.4 28S5.7 95 5.7 95l11.1-24.2s1.6-7.5 3.9-8.5",
    fill: "none"
    // stroke={appearance === 'inherit' ? `#fff` : '#000'}
    ,
    strokeWidth: "13",
    strokeMiterlimit: "10",
    mask: "url(#Mark)",
    appearance: appearance
  }))));
};
const markLines = keyframes(["0%,100%{stroke-dasharray:500;stroke-dashoffset:-850;}25%{stroke-dasharray:500;stroke-dashoffset:-442;}50%{stroke-dasharray:500;stroke-dashoffset:0;}75%{stroke-dasharray:500;stroke-dashoffset:-442;}"]);
const defaultMarkColors = keyframes(["0%{stroke:currentColor;}33%,50%{stroke:currentColor;}51%,66%{stroke:currentColor;}66%,100%{stroke:currentColor;}"]);
const inverseMarkColors = keyframes(["0%{stroke:#FFFFFF;}33%,50%{stroke:#FFFFFF;}51%,66%{stroke:#FFFFFF;}66%,100%{stroke:#FFFFFF;}"]);
const SVG = styled.svg.withConfig({
  displayName: "MktgSpinner__SVG",
  componentId: "sc-1ixak6e-0"
})([""]);
const Path = styled.path.withConfig({
  displayName: "MktgSpinner__Path",
  componentId: "sc-1ixak6e-1"
})(["stroke:", ";"], p => p.appearance === 'inherit' ? get('colors.elevation.surface.default.[default]') : 'currentColor');
const Wrapper = styled(Box).withConfig({
  displayName: "MktgSpinner__Wrapper",
  componentId: "sc-1ixak6e-2"
})(["", " ", " [data-animation]{animation:var(--animps,running);}.mark-foreground{stroke-dasharray:500;stroke-dashoffset:-850;}.mark-foreground{--animation-duration:5s;--animps:running;animation-name:", ";animation-duration:var(--animation-duration);animation-fill-mode:forwards;animation-iteration-count:infinite;}.mark-background{--animation-duration:5s;--animps:running;animation-name:", ";animation-duration:var(--animation-duration);animation-fill-mode:alternate;animation-iteration-count:infinite;}"], p => p.appearance === 'inherit' ? defaultMarkColors : inverseMarkColors, markLines, markLines, p => p.appearance === 'inherit' ? defaultMarkColors : inverseMarkColors);
const StyledMktgSpinner = styled(MktgSpinner).withConfig({
  displayName: "MktgSpinner__StyledMktgSpinner",
  componentId: "sc-1ixak6e-3"
})(["", ""], sx);
StyledMktgSpinner.displayName = 'MktgSpinner';
var MktgSpinner$1 = StyledMktgSpinner;

export { MktgSpinner$1 as default };
